"use client";

import { useActionState } from "react";
import Image from "next/image";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { handleLogin, type LoginActionState } from "./actions";

const INITIAL_STATE: LoginActionState = {};

export default function LoginPage() {
  const [state, formAction, isPending] = useActionState(
    handleLogin,
    INITIAL_STATE
  );

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <Card className="w-full max-w-xl shadow-lg">
        <div className="flex flex-col items-center px-6 pt-6 pb-2 text-center">
          <Image
            src="/angels-logo.png"
            alt="Angels Logo"
            width={200}
            height={54}
            priority
            className="h-auto w-auto max-w-[200px] object-contain"
          />
          <p className="mt-8 text-sm text-muted-foreground">
            Acesso ao sistema
          </p>
        </div>

        <CardContent>
          <form action={formAction} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="username">Usuário</Label>
              <Input
                id="username"
                name="username"
                type="text"
                placeholder="Digite seu usuário"
                autoComplete="username"
                required
                disabled={isPending}
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                name="password"
                type="password"
                placeholder="Digite sua senha"
                autoComplete="current-password"
                required
                disabled={isPending}
              />
            </div>

            {state.error && (
              <p className="text-center text-sm font-medium text-destructive">
                {state.error}
              </p>
            )}

            <Button type="submit" disabled={isPending} className="w-full">
              {isPending ? "Entrando..." : "Entrar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
